"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 1rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0;\n\n  & > svg {\n    cursor: pointer;\n  }\n\n  /* editable-text-option-row */\n  & > div {\n    flex: 1;\n  }\n\n  /* \u30BD\u30FC\u30C8\u6642\u306B\u96A0\u308C\u3066\u3057\u307E\u3046\u305F\u3081\u5BFE\u7B56 \n    \n    sortableList \u306F sort \u6642\u306B body \u76F4\u4E0B\u306B SortableElement (\u4ECA\u56DE\u306E\u5834\u5408 StyledSortableLi) \u3092 rendering (https://github.com/clauderic/react-sortable-hoc#prop-types \u306E helperContainer)\n    \u5E38\u306B stacking context \u3092\u4F5C\u6210\u3059\u308B\u3068 variable-texteditor \u306E\u3000overlay \u304C\u6A5F\u80FD\u3057\u306A\u304F\u306A\u308B\u306E\u3067\u3001\n    sort\u6642\u306E\u307F stacking context \u3092\u4F5C\u6210 (stacking context >>> https://coder-coder.com/z-index-isnt-working/)\n   */\n  body > & {\n    position: relative;\n    z-index: 2;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledSortableLi = styled_components_1.default.li(_templateObject());
exports.StyledSortableUl = styled_components_1.default.ul(_templateObject2());